import React, { Component } from "react";
import * as R from "ramda";
import FlexView from "react-flexview";
import { configNo, configLast3Years, yearOptions, transformResponseLastThreeYearsToTable } from "../config";
import { removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleUploadImage from "../../../../../modules/upload/SimpleUploadImage";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { service } from "./service";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";

class LastThreeYearsSalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            tableConfig: [],
            dataTable: [],
            chartVisible: false,
            chartLast3Years: null,
        };
    };

    componentDidMount() {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            year: yearOptions.find(
                (item) => item.value === currentDate.getFullYear()
            ),
            tableConfig: [
                ...configNo,
                { name: "name", label: "Cabang", options: { sort: false } },
                ...configLast3Years(),
            ],
        }));
    }

    // componentDidUpdate = async (prevProps) => {
    //     if (!R.equals(prevProps.search, this.props.search)) {
    //         this.fetchData();
    //     }
    // };

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleChartVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            chartVisible: !prevValue.chartVisible,
        }));
    };

    fetchData = async () => {
        try {
            this.props.triggerLoading();
            const request = {
                kodeCabang: this.props.search,
                year: this.state.year?.value,
                mode: "CABANG",
                idLeader: this.props.idLeader,
                // employeeIdTeamLeader: this.props.idLeader,
                idSalesman: null
            };
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhir,
                menuName: "Dashboard Koordinator - Laporan Jualan 3 Tahun Terakhir",
                setError: this.props.setError,
                args: request,
            });

            console.log(request);


            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: transformResponseLastThreeYearsToTable(res.data.data),
                }));
            }
            this.props.triggerLoading();
        } catch (error) {
            this.props.triggerLoading();
            console.log("errors: ", error);
        }
    };

    handleSearch = () => {
      this.setState(
        (prev) => ({
          ...prev,
          tableConfig: [
            ...configNo,
            { name: "name", label: "Cabang", options: { sort: false } },
            ...configLast3Years(prev.year?.value),
          ],
        }),
        () => this.fetchData(),
      );
    };

    render() {
        const { data, dataKey } = service.transformChartData(
            this.state.dataTable, this.state.tableConfig
        );
        return (
            <>
                <FlexView style={{ gap: "20px", alignItems: "center" }}>
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        isClearable
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, { name }) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{ marginBottom: "15px" }}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                {!this.state.chartVisible && (
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.state.tableConfig}
                    />
                )}
                {this.state.chartVisible && (
                    <CardBiaxialChart data={data} dataKey={dataKey} />
                )}
                <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
                    <SimpleButton onClick={this.handleChartVisibility}>Chart</SimpleButton>
                </FlexView>
            </>
        );
    }
}

export default LastThreeYearsSalesReport;